// 編輯頁的「時間預覽」：拉時間尺 / 按播放時，3D 的機關停在那個時間（物件還是停在目前選的 cue）。
// 開始改任何東西（移動 / 旋轉 / 改值 / 另存 / 覆蓋 cue / 拖機關滑桿）、換 cue、換歌 → 先結束預覽，
// 3D 回到那個 cue 的姿勢，才不會改到錯的姿勢，也不會把預覽中的姿勢存進去。

export interface TimePreviewDeps {
  /** 時間軸 / 音樂寫進去的預覽時間；null = 沒在預覽 */
  previewTimeRef: { current: number | null };
  setPreviewTime: (t: number | null) => void;
  /** 有音樂跟著時：停掉音樂（暫停、回到開頭）；沒有就不給 */
  stopMusic?: (() => void) | null;
  /** 通知時間軸收起播放頭、停掉自己的播放 */
  bumpStop: () => void;
}

/** 結束時間預覽。回 true = 剛才真的在預覽（現在結束了）；false = 本來就沒在預覽，什麼都沒動 */
export function endTimePreview(d: TimePreviewDeps): boolean {
  if (d.previewTimeRef.current === null) return false;
  if (d.stopMusic) d.stopMusic();
  d.setPreviewTime(null);
  d.bumpStop();
  return true;
}
